// @flow
import * as yup from "yup";

// eslint-disable-next-line no-unused-vars
import schemaErrorMessages from "../../../utils/schemaErrorMessages";

const getStatsSchema: Object = yup.object().shape({
  updated_at: yup.date().nullable(),
  statuses: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number().required(),
        name: yup.string().required(),
        total: yup.number().required(),
      })
    )
    .nullable(),
  top_categories: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number().required(),
        name: yup.string().required(),
        total: yup.number().required(),
      })
    )
    .nullable(),
  top_sources: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number().required(),
        name: yup.string().required(),
        total: yup.number().required(),
      })
    )
    .nullable(),
});

export default getStatsSchema;
